// @flow
import React from 'react';
import { FormGroup, Button } from 'reactstrap';
import { withRouter } from 'react-router-dom';
import { WhitePanelLayout, FormSubmitButton } from '@dom/components';
import { Form } from '@sharingapples/form';
import differenceInDays from 'date-fns/difference_in_calendar_days';
import addDays from 'date-fns/add_days';
import format from 'date-fns/format';
// import queryString from 'query-string';

import { useSelector } from '../../redux';
import { updateGuideSearchQuery } from '../../redux/actors';
import { getGuideSearchQuery,  } from '../../redux/selectors';
import { useToggle } from '../../hooks';

import {
  GuidePax,
  GuideBookingDates,
  GuideSearchInput,
} from '../../components/GuideSearchFormElements';

const DATE_FORMAT = 'YYYY-MM-DD';
// const DISPLAY_DATE_FORMAT = 'dddd, MMMM M, YYYY'; 
const DISPLAY_DATE_FORMAT = 'MMMM DD, YYYY';

const INITIAL_VALUES = {
  pax: 1,
  guideQuery:'',
};

function SearchForm() {
  const guideSearchQuery = useSelector(getGuideSearchQuery) || INITIAL_VALUES;
  const { guideQuery, pax, startDate, endDate } = guideSearchQuery;
  const { on, open, close } = useToggle(!Boolean(guideQuery) && !Boolean(startDate));

  const handleSubmit = (state) => {
    const query = { ...state };
    if (!query.guideQuery) query.guideQuery = 'Everest Base Camp';
    if(!query.startDate) {
      // IF START DATE IS EMPTY SET ITS VALUES TO A MONTH FROM NOW AND END DATE TO 14 DAYS AFTER START DATE 
      const aMonthFromNow = format(addDays(new Date(), 30), DATE_FORMAT);
      const fifteenDaysFromAMonth = format(addDays(aMonthFromNow, 14), DATE_FORMAT);

      query.startDate = aMonthFromNow;
      query.endDate = fifteenDaysFromAMonth;
    }
    const { startDate, endDate } = query;
    const  numberOfDays = differenceInDays(endDate, startDate) + 1;

    updateGuideSearchQuery({ ...query, numberOfDays });
    close();
  }

  return (
    <WhitePanelLayout title={ on ? 'Select Date':'Your Selection'} id="modify-selection-form">
      <Form defaultValue={guideSearchQuery} onSubmit={handleSubmit}>
        {
          on ? (
            <div className="fullwrap" id="fullWrap">
              <GuideSearchInput wrap autoFocus={false} tabIndex={1} label='Trek Name'/>
              <GuideBookingDates label='Trek Date'/>
              <GuidePax label='No. Of Trekkers'/>
              <FormGroup>
                <label style={{visibility: "hidden"}}>Seach Button</label>
                <FormSubmitButton buttonText='Change Search'/>
              </FormGroup>
            </div>
          ) : (
            <div className="selection-result">
              <div className="info-box">
                <p className="title">Trek Name</p>
                <p>{guideQuery}</p>
              </div>
              <div className="info-box">
                <p className="title">Trek Start - End Date:</p>
                <p>{format(startDate, DISPLAY_DATE_FORMAT)} - {format(endDate, DISPLAY_DATE_FORMAT)}</p>
              </div>
              <div className="info-box">
                <p className="title">Guest</p>
                <p>{pax}</p>
              </div>
              <div className="info-box">
              <Button onClick={open} color="yellow" size="sm">Change Search</Button>
              </div>
            </div>
          )
        }
      </Form>
    </WhitePanelLayout>
  );
};

export default withRouter(SearchForm);
